// extracted by mini-css-extract-plugin
export default {"SidebarCardHeader":"sidebarCardHeader-module_SidebarCardHeader_OqXbt"};